import React, { useEffect, useState, memo } from "react";
import { get } from "lodash";
import { connect } from "react-redux";
import Dialog from "../ui/Dialog";
import FileList from "../FileList";
import _actions from "../../_actions";

const FileManager = props => {
  const [showMedia, setShowMedia] = useState(props.show);
  const [selectedFiles, setSelectedFiles] = useState(props.selectedFiles || []);

  useEffect(() => {
    setShowMedia(props.show);
  }, [props.show]);

  useEffect(() => {
    if (get(props, "selectedFiles.length") !== selectedFiles) {
      setSelectedFiles(props.selectedFiles);
    }
  }, [props.selectedFiles]);

  return (
    <Dialog
      style={{ display: showMedia ? "block" : "none" }}
      maxWidth="lg"
      title="Files"
      open
      onClose={props.hideFileManager}
    >
      <FileList
        addFile={props.addFile}
        removeFile={props.removeFile}
        selectedFiles={selectedFiles}
      />
    </Dialog>
  );
};

export default connect(
  ({ appState: { fileManager = {} } }) => ({
    selectedFiles: fileManager.selectedFiles,
    show: fileManager.show,
    addFile: fileManager.addFile,
    removeFile: fileManager.removeFile
  }),
  {
    hideFileManager: () =>
      _actions.updateFileManager({
        show: false,
        addFile: null,
        removeFile: null,
        selectedFiles: []
      })
  }
)(memo(FileManager, (pp, np) => !pp.show && !np.show));
